<template>
  <div class="contact-list">
    <!-- 联系人列表（企业微信手机端，仅查看） -->
    <mobile-list-header>
      <!-- 第一行：搜索框占满整行，左输入框 + 右搜索按钮 -->
      <div class="search-bar">
        <div class="search-input">
          <yq-icon class="icon" name="element-ui_search"/>
          <input v-model="searchInfo.searchKey" placeholder="联系人姓名/手机号" @keyup.enter="resetSearch"/>
          <yq-icon v-if="searchInfo.searchKey" class="icon clear" name="element-ui_close" @click="clearKey"/>
        </div>
        <div class="search-btn" @click="resetSearch">搜索</div>
      </div>
      <!-- 第二行：查询条件，无背景色，超过一屏横向滑动 -->
      <div class="filter-row">
        <mobile-search-select v-model="searchInfo.customerId" :query="queryCustomerPage" size="small"
                              label-column="merchantRemarkName" code-column="id"
                              placeholder="所属客户" search-placeholder="客户名称/手机号"
                              @change="resetSearch">
          <template #item="{item}">
            <div class="mss-item">
              <div class="mss-item-main">{{ item.merchantRemarkName }}</div>
              <div class="mss-item-sub">{{ item.merchantRemarkPhone || "无联系电话" }}</div>
            </div>
          </template>
        </mobile-search-select>
        <mobile-condition-select v-model="searchInfo.customerPosition" :data="positionList"
                                 label-column="dictName" code-column="userCode" type="list"
                                 placeholder="职位" @change="resetSearch"/>
      </div>
    </mobile-list-header>
    <mobile-list :loading="loading" :has-more="searchInfo.hasMore" :query-list="queryList"
                 :refresh="resetSearch" ref="mobileList">
      <list-card class="contact-item" v-for="item in dataList" :key="item.id" :label="item.merchantRemarkName">
        <template #desc>
          <span v-if="Number(item.keyContact) === KEY_CONTACT.YES" class="type-tag key">关键人</span>
        </template>
        <data-column label="所属客户">{{ item.customerName || "—" }}</data-column>
        <data-column label="职位">{{ dictName(positionList, item.customerPosition) || "—" }}</data-column>
        <data-column label="手机号">{{ item.merchantRemarkPhone || "—" }}</data-column>
      </list-card>
    </mobile-list>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import MobileList from "@/components/qywx/layout/MobileList.vue";
import MobileListHeader from "@/components/qywx/layout/MobileListHeader.vue";
import MobileConditionSelect from "@/components/qywx/data/MobileConditionSelect.vue";
import MobileSearchSelect from "@/components/qywx/data/MobileSearchSelect.vue";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import YqIcon from "@/components/YqIcon.vue";
import contactApi from "@/api/dz-crm/partner/contactApi";
import commonDataApi from "@/api/normal/common/commonDataApi";
import commonApi from "@/api/commonApi";
import {DICT_CUSTOMER_POSITION, KEY_CONTACT, PARTNER_TYPE, dictName} from "@/views/h5/crm/crmDictionary";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "ContactListQW",
  components: {
    YqIcon, DataColumn, ListCard, MobileSearchSelect, MobileConditionSelect, MobileListHeader, MobileList
  },
  data() {
    return {
      loading: false,
      searchInfo: {
        searchKey: "",
        customerId: "",
        customerPosition: "",
        pageNumber: 0,
        pageSize: 20,
        hasMore: true, // 初始为 true，列表挂载后由无限滚动自动触发首次查询
      },
      dataList: [],
      positionList: [],
      // 常量暴露给模板用
      KEY_CONTACT,
    };
  },
  created() {
    commonApi.queryUniqueDictionaryList(DICT_CUSTOMER_POSITION).then(list => this.positionList = list || []);
  },
  methods: {
    dictName,
    queryList() {
      this.loading = true;
      this.searchInfo.pageNumber++;
      contactApi.queryList({
        ...this.cleanParams(),
        pageNumber: this.searchInfo.pageNumber,
        pageSize: this.searchInfo.pageSize,
      }).then(res => {
        this.dataList = this.dataList.concat(res.records || []);
        this.searchInfo.hasMore = res.pageCount > this.searchInfo.pageNumber;
        this.loading = false;
        this.$refs.mobileList.hideRefreshTitle();
      }).catch(() => {
        this.loading = false;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 0;
      this.dataList = [];
      this.searchInfo.hasMore = true;
      this.queryList();
    },
    clearKey() {
      this.searchInfo.searchKey = "";
      this.resetSearch();
    },
    // 空值不提交，避免空串绑到后端字段
    cleanParams() {
      const params = {};
      ["searchKey", "customerId", "customerPosition"].forEach(key => {
        const value = this.searchInfo[key];
        if (value !== "" && value !== null && value !== undefined) {
          params[key] = value;
        }
      });
      return params;
    },
    // 客户选择框的数据源：走通用往来单位接口（带数据权限），需要显式传 partnerType
    queryCustomerPage(params) {
      return commonDataApi.queryPartnerList({...params, partnerType: PARTNER_TYPE.CUSTOMER});
    },
  }
};
</script>

<style lang="scss" scoped>
.contact-list{
  height: 100%;
  display: flex;
  flex-direction: column;
}
// 第一行：搜索框占满整行，左输入框 + 右搜索按钮
.search-bar{
  display: flex;
  align-items: center;
  height: 44px;
  padding-left: 12px;
  border-radius: 999px;
  background: var(--yq-background-color);
  overflow: hidden;
  .search-input{
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    height: 100%;
    padding-right: 12px;
    .icon{
      flex: none;
      color: var(--yq-font-color-desc);
      font-size: var(--yq-font-size-mini-mobile);
      &.clear{
        margin-left: 6px;
      }
    }
    input{
      flex: 1;
      min-width: 0;
      height: 100%;
      margin-left: 6px;
      border: none;
      outline: none;
      background: transparent;
      font-size: var(--yq-font-size-mini-mobile);
      color: var(--yq-font-color-base);
      &::placeholder{
        color: var(--yq-font-color-desc);
      }
    }
  }
  .search-btn{
    flex: none;
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0 18px;
    background: var(--el-color-primary);
    color: #FFF;
    font-size: var(--yq-font-size-mini-mobile);
  }
}
// 第二行：查询条件，无背景色，超过一屏横向滑动
.filter-row{
  display: flex;
  gap: 18px;
  margin-top: 10px;
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar{
    display: none;
  }
  > *{
    flex: none;
  }
}
.contact-item{
  .type-tag{
    padding: 2px 8px;
    border-radius: 4px;
    font-size: var(--yq-font-size-mini-mobile);
    &.key{
      color: var(--el-color-warning);
      background: var(--el-color-warning-light-9);
    }
  }
}
</style>
